import React from "react"
import ContentLoader from "react-content-loader"
import './styles.scss';

const ContentOverviewLiveSkeleton = (props) => (
  <div style={{ display: 'flex' }}>
    <ContentLoader height="350" width="450" viewBox="0 0 450 350" {...props}>
      {/** TITLE */}
      <rect x="15" y="15" rx="4" ry="4" width="350" height="50" />
      {/** BUTTONS */}
      <rect x="15" y="95" rx="3" ry="3" width="70" height="30" />
      <rect x="95" y="95" rx="3" ry="3" width="70" height="30" />
      <rect x="175" y="95" rx="3" ry="3" width="70" height="30" />
      {/** TEXT */}
      <rect x="15" y="165" rx="4" ry="4" width="200" height="15" />
      <rect x="235" y="165" rx="3" ry="3" width="200" height="15" />
      <rect x="15" y="200" rx="3" ry="3" width="120" height="15" />
      <rect x="145" y="200" rx="3" ry="3" width="80" height="15" />
      <rect x="235" y="200" rx="3" ry="3" width="200" height="15" />
    </ContentLoader>
  </div>
)

export default ContentOverviewLiveSkeleton;

/**  <rect x="15" y="145" rx="2" ry="2" width="250" height="50" /> */
/*
      <rect x="15" y="290" rx="3" ry="3" width="130" height="15" />
      <rect x="160" y="290" rx="3" ry="3" width="120" height="15" />
      <rect x="290" y="290" rx="3" ry="3" width="95" height="15" />
      <rect x="15" y="330" rx="3" ry="3" width="130" height="15" />
<rect x="160" y="330" rx="3" ry="3" width="225" height="15" />*/